<template>

<div class="field" :class="{'is-locked': field.locked}">

    <div class="field-info" v-on:click="onClick">

        <div class="field-name">{{ item.lang.name }}</div>

        <div class="field-category" v-if="categories.length">
            <span v-for="(category, index) in categories" :key="index">{{ category }}</span>
        </div>

    </div>

    <div class="field-move is-up" :class="{'is-disabled': isFirst}" v-on:click="$emit('up')" v-if="!field.locked">

        <i class="fa-solid fa-caret-up" />

    </div>

    <div class="field-move" :class="{'is-disabled': isLast}" v-on:click="$emit('down')" v-if="!field.locked">

        <i class="fa-solid fa-caret-down" />

    </div>

</div>

</template>

<script>

import $field from '@/field.js'

export default {

	props: ['field', 'view', 'isLast', 'isFirst'],

    computed: {

        categories: function() {

            var tags = []

            if (this.field.label && (this.field.label !== this.item.default.label || !this.item.default.label)) {

                tags.push(this.field.label)

            }

            if (this.field.width === 'custom') {

                tags.push(((this.field.customwidth) ? this.field.customwidth.toString() : '0') + 'px')

            }

            if(this.field.sticky) {
                
                if (this.field.sticky === 1) tags.push('sticky')
                if (this.field.sticky === 2) tags.push('sticky on large screens')

            }
            
            if(this.field.devices) {

                if (this.field.devices === 1) tags.push('large screens')
                if (this.field.devices === 2) tags.push('small screens')
                if (this.field.devices === 3) tags.push('demote on small screens')

            }

            if(this.field.sorts.length) {

                tags.push(this.field.sorts.length.toString() + ' sort' + ((this.field.sorts.length === 1) ? '' : 's'))

            }

            if(this.field.filters.length) {

                tags.push(this.field.filters.length.toString() + ' filter' + ((this.field.filters.length === 1) ? '' : 's'))

            }

            this.$_.each(this.item.unique, function(setting) {

                var visible = (setting.visibility) ? setting.visibility(this.field, this.view) : true

                if (setting.contexts && visible) {

                    visible = this.$_.contains(setting.contexts, this.$currentViewContext)

                }

                if (setting.views && visible) {

                    visible = this.$_.contains(setting.views, this.viewLayout)

                }

                if (visible) {

                    if (setting.default && setting.default !== this.field[setting.key] && this.field[setting.key] !== undefined) {

                        if (setting.preview) {

                            tags.push(setting.preview(this.field[setting.key]))

                        } else if (setting.type === 'checklist') {

                            var option = this.$_.findWhere(setting.options, {
                                value: this.field[setting.key]
                            })

                            tags.push(option.preview || option.text)

                        }

                    }

                }

            }.bind(this))

            return tags

        },

        item: function() {

            return $field.type[this.field.type]

        },

        // Layout name derived from the view being edited (passed as the
        // `view` prop), not the current page's active view. Avoids a
        // crash in Shortcuts.$currentViewType when this Field is
        // rendered inside the View modal where `this.currentView` is
        // undefined.
        viewLayout: function() {

            if (!this.view) return false
            if (this.view.type === 1) return 'list'
            if (this.view.type === 2) return 'sheet'
            if (this.view.type === 3) return 'grid'
            if (this.view.type === 4) return 'gallery'

            return false

        }

    },

    methods: {

        onClick: function() {

            this.$pubsub.$emit('open.modal', {
				id: 'viewsViewField',
                model: this.field,
				view: this.view.id
			})

        }

    }

}

</script>

<style scoped>

.field {
    border-bottom: 1px solid rgb(54, 97, 119);
    cursor: pointer;
    display: grid;
    grid-template-columns: 1fr 32px 32px;
    grid-gap: 5px;
    user-select: none;
    align-items: center;
    padding-right: 20px;
}

.is-mobile .field {
    padding-right: 10px;
}

.field.is-locked {
    grid-template-columns: 1fr;
}

.is-mobile .field {
    border-bottom: 1px solid #eee;
}

.is-desktop .field:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

.field-info {
    padding: 15px 0px 15px 20px;
}

.is-mobile .field-info {
    padding: 15px 0px 15px 10px;
}

.field-name {
    font-weight: 500;
    color: #fff;
    line-height: 20px;
    font-size: 16px;
}

.is-mobile .field-name {
    color: #343434;
}

.field-category {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    margin-top: 2px;
}

.field-category span {
    font-weight: 500;
    line-height: 12px;
    font-size: 12px;
    border-radius: 4px;
    text-transform: lowercase;
    padding: 2px 4px;
    background-color: rgba(255, 255, 255, 0.3);
    color: #0a2b3d;
}

.is-mobile .field-category span {
    background-color: rgba(0, 0, 0, 0.4);
    color: #fff;
}

.field-move {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-color: #4881bb;
    color: #fff;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    cursor: pointer;
}

.field-move.is-disabled {
    pointer-events: none;
    opacity: 0.2;
}

.field-move.is-up {
    line-height: 36px;
}

.field-move:hover {
    background-color: #356ca4;
}

</style>